export default __webpack_public_path__ + "static/media/Pro-1b.cb73a2f0.png";